import { Component } from '@angular/core';
import { HeaderComponent } from "../../../../layout/header/header.component";
import { NavbarComponent } from "../../../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../../../layout/sidebar/sidebar.component";
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { DiscountService } from '../../../../services/discountService.service';
import { DiscountControlCheckValueDto, DiscountControlCheckValueRequest, DiscountControlCheckValueResponse } from '../../../../models/discountGeneralCatalog/DiscountControlCheckValue.model';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from "../../../../components/paginator/paginator.component";
import { AlertComponentComponent } from "../../../../components/alert/alert-component.component";
import { GeneralDiscountCatalogDto, GeneralDiscountCatalogRequest, GeneralDiscountCatalogResponse } from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountControlTypeDto, DiscountControlTypesRequest } from '../../../../models/discountGeneralCatalog/DiscountControlTypesDto.model';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../../services/shared.service';
import { DiscountAssociationsControlTypesDto } from '../../../../models/discountGeneralCatalog/DiscountAssociationsControlTypesDto.model';

@Component({
  selector: 'app-types-control-discount',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, TranslatePipe, ReactiveFormsModule, CommonModule, PaginatorComponent, AlertComponentComponent],
  templateUrl: './types-control-discount.component.html',
  styleUrl: './types-control-discount.component.css'
})
export class TypesControlDiscountComponent {
  links: any[] = []; // Lista de links para el sidebar
  discountTypeReponse: DiscountControlCheckValueResponse = new DiscountControlCheckValueResponse();
  discountTypeRequest: DiscountControlCheckValueRequest = new DiscountControlCheckValueRequest();
  discountTypeSelected: DiscountControlCheckValueDto = new DiscountControlCheckValueDto();
  typeRequest: DiscountControlTypesRequest = new DiscountControlTypesRequest();
  discountRequest: GeneralDiscountCatalogRequest = new GeneralDiscountCatalogRequest();
  discountReponse: GeneralDiscountCatalogResponse = new GeneralDiscountCatalogResponse();

  listGeneralDiscountCatalogDto: GeneralDiscountCatalogDto[] = [];
  listDiscountControlType: DiscountControlTypeDto[] = [];
  selectedRowId: number | null = null;
  discountTypeForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility();
  private langChangeSubscription!: Subscription;

  constructor(private translateService: TranslateService,
    private routelinks: RoutelinksService,
    private discountService: DiscountService,
    private formBuilder: FormBuilder,
    public sharedService: SharedService) { }


  ngOnInit(): void {
    this.links = this.routelinks.linksDiscount;
    this.initFormReactiveDiscountType()
    this.loadDiscountsTypes();
    this.loadDiscounts();
    this.loadDiscountControlTypes()
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadDiscountsTypes();
      this.loadDiscounts();
      this.loadDiscountControlTypes()
    });
    this.discountTypeForm.get('idDiscountControlType')?.valueChanges.subscribe((value) => {
      if (this.listDiscountControlType.length == 0) { return }
      if (this.listDiscountControlType.filter(list => { return list.idDiscountControlType == value })[0].controlValueType == 'NI') {
        this.discountTypeForm.get('alphanumericValue')?.disable()
        this.discountTypeForm.get('decimalValue')?.disable()
        this.discountTypeForm.get('numericValue')?.disable()
        this.discountTypeForm.get('dateStart')?.disable()
        this.discountTypeForm.get('dateEnd')?.disable()
        this.discountTypeForm.get('intervalValueStart')?.disable()
        this.discountTypeForm.get('intervalValueEnd')?.disable()
      } else if (this.listDiscountControlType.filter(list => { return list.idDiscountControlType == value })[0].controlValueType == 'NU') {
        this.discountTypeForm.get('alphanumericValue')?.disable()
        this.discountTypeForm.get('decimalValue')?.disable()
        this.discountTypeForm.get('numericValue')?.enable()
        this.discountTypeForm.get('dateStart')?.disable()
        this.discountTypeForm.get('dateEnd')?.disable()
        this.discountTypeForm.get('intervalValueStart')?.disable()
        this.discountTypeForm.get('intervalValueEnd')?.disable()
      } else if (this.listDiscountControlType.filter(list => { return list.idDiscountControlType == value })[0].controlValueType == 'DA') {
        this.discountTypeForm.get('alphanumericValue')?.disable()
        this.discountTypeForm.get('decimalValue')?.disable()
        this.discountTypeForm.get('numericValue')?.disable()
        this.discountTypeForm.get('dateStart')?.enable()
        this.discountTypeForm.get('dateEnd')?.enable()
        this.discountTypeForm.get('intervalValueStart')?.disable()
        this.discountTypeForm.get('intervalValueEnd')?.disable()
      } else if (this.listDiscountControlType.filter(list => { return list.idDiscountControlType == value })[0].controlValueType == 'ID') {
        this.discountTypeForm.get('alphanumericValue')?.disable()
        this.discountTypeForm.get('decimalValue')?.disable()
        this.discountTypeForm.get('numericValue')?.disable()
        this.discountTypeForm.get('dateStart')?.disable()
        this.discountTypeForm.get('dateEnd')?.disable()
        this.discountTypeForm.get('intervalValueStart')?.enable()
        this.discountTypeForm.get('intervalValueEnd')?.enable()
      }
      this.resetValues()
    });


    // Activa la notifiación de cambio de pagina en el paginador
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      //this.discountRequest.pageRequest.page = page;
      this.discountTypeRequest.pageRequest.page = page;
      this.loadDiscountsTypes();
      //this.loadDiscounts();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  private initFormReactiveDiscountType(): void {
    this.discountTypeForm = this.formBuilder.group({
      idDiscountControlCheckValues: [0],
      alphanumericValue: [0],
      numericValue: [0],
      decimalValue: [0],
      idGeneralDiscountCatalog: [null, [Validators.required]],
      idDiscountControlType: [null],
      dateStart: [''],
      dateEnd: [''],
      intervalValueStart: [null],
      intervalValueEnd: [null],
    });
  }

  loadDiscountsTypes() {
    this.discountService.getListDiscountControlCheckValue(this.discountTypeRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.discountTypeReponse.DiscountControlTypesDto = response.listDiscountControlCheckValue
          response.pageDto !== undefined ? this.discountTypeReponse.pageDto = response.pageDto : null
          console.log('9999', this.discountTypeReponse.DiscountControlTypesDto)
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  // Funcion que devuelve el select para los descuentos a asginar
  loadDiscounts() {
    // Forzamos a que nos muestre todos los registros.
    this.discountRequest.pageRequest.sizePage = 100;
    this.discountService.getListGeneralDiscountCatalog(this.discountRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listGeneralDiscountCatalogDto = response.listGeneralDiscountCatalog.map((rt: any) => {
            return {
              ...rt,
              generalDiscountCatalogTraductionDto: rt.generalDiscountCatalogTraductionDto
                .filter((t: any) => t.languageDto.code.includes(this.translateService.currentLang || 'es'))
            };
          });
        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountControlTypes() {
    this.discountService.getListDiscountControlType(this.typeRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listDiscountControlType = response.listDiscountControlType;
          console.log('6666', this.listDiscountControlType)
        }
      }, error: error => {
      }
    });
  }

  checkRow(discount?: DiscountControlCheckValueDto) {
    if (discount) {
      if (this.selectedRowId === discount.idDiscountControlCheckValues) {
        this.selectedRowId = null;
        return;
      }
      // Modo edición
      this.discountService.getListDiscountControlCheckValueById(discount.idDiscountControlCheckValues).subscribe(response => {
        this.patchDiscountForm(response);
        this.discountTypeForm.get('idDiscountControlCheckValues')?.disable()
        this.discountTypeSelected = response
        this.selectedRowId = Number(response.idDiscountControlCheckValues);
        this.isCreate = false;
        this.discountTypeForm.get('numericValue')?.patchValue(response.numericValue)
        this.discountTypeForm.get('dateStart')?.patchValue(response.dateStart)
        this.discountTypeForm.get('dateEnd')?.patchValue(response.dateEnd)
      })
    } else {
      // Modo creación
      this.selectedRowId = null;
      this.isCreate = true;
      this.discountTypeForm.enable();
      this.discountTypeForm.reset();
      this.discountTypeForm.get('alphanumericValue')?.disable()
      this.discountTypeForm.get('decimalValue')?.disable()
      this.discountTypeForm.get('numericValue')?.disable()
      this.discountTypeForm.get('dateStart')?.disable()
      this.discountTypeForm.get('dateEnd')?.disable()
    }
    window.scrollTo(0, 600);
  }

  patchDiscountForm(discount: DiscountControlCheckValueDto) {
    this.discountTypeForm.patchValue({
      idDiscountControlCheckValues: discount.idDiscountControlCheckValues,
      alphanumericValue: discount.alphanumericValue,
      numericValue: discount.numericValue,
      decimalValue: discount.decimalValue,
      dateStart: discount.dateStart,
      dateEnd: discount.dateEnd,
      idGeneralDiscountCatalog: discount.generalDiscountCatalogDto?.idGeneralDiscountCatalog,
      idDiscountControlType: discount.discountControlTypeDto?.idDiscountControlType,
    });
  }

  createOrUpdateDiscount() {
    if (this.controlDates(this.discountTypeForm.get('dateStart')?.value, this.discountTypeForm.get('dateEnd')?.value)) {
      this.messageVisibility.isErrorFirts = true
      this.messageVisibility.isSuccessFirst = false
      this.errorMessage = 'fechas';
      return
    }
    /*
    if (!this.compareIntervalValues()) {
       this.messageVisibility.isErrorFirts = true
      this.messageVisibility.isSuccessFirst = false
      this.errorMessage = 'intervalos';
      return
    }*/
    if (this.discountTypeForm.valid) {

      this.objTypeControlDiscount()
      if (!this.selectedRowId) {
        let associationType: DiscountAssociationsControlTypesDto = {
          discountAssociatedControlTypePkDto: { discountControlTypeId: this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType || 0, generalDiscountCatalogId: this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog },
          discountControlTypeDto: { idDiscountControlType: this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType || 0 },
          generalDiscountCatalogDto: { idGeneralDiscountCatalog: this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog }
        }
        this.discountService.insertAssociationsControlTypes(associationType, this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog, this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType).subscribe({
          next: (response) => {
            this.discountService.insertDiscountControlCheckValue(this.discountTypeRequest.DiscountControlTypesDto).subscribe({
              next: (response) => {
                this.messageVisibility.isErrorFirts = false;
                this.messageVisibility.isSuccessFirst = true;
                this.errorMessage = "S'ha creat correctament"
                this.loadDiscountsTypes();
              }, error: (error) => {
                this.messageVisibility.isErrorFirts = true;
                this.messageVisibility.isSuccessFirst = false;
                this.errorMessage = error.error.message
              }
            })
            this.messageVisibility.isErrorFirts = false;
            this.messageVisibility.isSuccessFirst = true;
            this.errorMessage = "S'ha creat correctament"
            this.loadDiscountsTypes();
          }, error: (error) => {
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })
      }
      //modo edicion
      else {
        let associationType: DiscountAssociationsControlTypesDto = {
          discountAssociatedControlTypePkDto: { discountControlTypeId: this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType || 0, generalDiscountCatalogId: this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog },
          discountControlTypeDto: { idDiscountControlType: this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType || 0 },
          generalDiscountCatalogDto: { idGeneralDiscountCatalog: this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog }
        }
        this.discountService.updateAssociationsControlTypes(associationType, this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto?.idGeneralDiscountCatalog, this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto?.idDiscountControlType).subscribe({
          next: (response) => {
            this.discountService.updateDiscountControlCheckValue(this.discountTypeRequest.DiscountControlTypesDto).subscribe({
              next: (response) => {
                this.messageVisibility.isErrorFirts = false;
                this.messageVisibility.isSuccessFirst = true;
                this.errorMessage = "S'ha editat correctament"
                this.loadDiscountsTypes()
              }, error: (error) => {
                this.messageVisibility.isErrorFirts = true;
                this.messageVisibility.isSuccessFirst = false;
                this.errorMessage = error.error.message
              }
            })
            this.loadDiscountsTypes();
          }, error: (error) => {
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })

      }
    } else {
      this.messageVisibility.isErrorFirts = true;
      this.messageVisibility.isSuccessFirst = false;
      this.errorMessage = 'obligatorios'
    }
  }

  objTypeControlDiscount() {
    this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto = new DiscountControlTypeDto()
    this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto = new GeneralDiscountCatalogDto()
    this.selectedRowId ? this.discountTypeRequest.DiscountControlTypesDto.idDiscountControlCheckValues = this.selectedRowId || undefined : null // Asigna el ID de la tasa académica seleccionada
    this.discountTypeRequest.DiscountControlTypesDto.dateStart = this.discountTypeForm.get('dateStart')?.value
    this.discountTypeRequest.DiscountControlTypesDto.dateEnd = this.discountTypeForm.get('dateEnd')?.value
    this.discountTypeRequest.DiscountControlTypesDto.alphanumericValue = this.discountTypeForm.get('alphanumericValue')?.value
    this.discountTypeRequest.DiscountControlTypesDto.decimalValue = this.discountTypeForm.get('decimalValue')?.value
    this.discountTypeRequest.DiscountControlTypesDto.numericValue = this.discountTypeForm.get('numericValue')?.value
    this.discountTypeRequest.DiscountControlTypesDto.decimalStart = this.discountTypeForm.get('intervalValueStart')?.value
    this.discountTypeRequest.DiscountControlTypesDto.decimalEnd = this.discountTypeForm.get('intervalValueEnd')?.value
    this.discountTypeRequest.DiscountControlTypesDto.discountControlTypeDto.idDiscountControlType = this.discountTypeForm.get('idDiscountControlType')?.value
    this.discountTypeRequest.DiscountControlTypesDto.generalDiscountCatalogDto.idGeneralDiscountCatalog = this.discountTypeForm.get('idGeneralDiscountCatalog')?.value
  }

  resetValues() {
    this.discountTypeForm.get('alphanumericValue')?.patchValue(null)
    this.discountTypeForm.get('decimalValue')?.patchValue(null)
    this.discountTypeForm.get('numericValue')?.patchValue(null)
    this.discountTypeForm.get('dateStart')?.patchValue(null)
    this.discountTypeForm.get('dateEnd')?.patchValue(null)
  }

  getNameDiscount(discounts: any): string {
    return discounts.filter((disc: { code: string; }) => { return disc.code == this.translateService.currentLang || 'es' })[0].discountDescription
  }

  controlDates(startDate: any, dateEnd: any): boolean {
    if (!dateEnd) { return false }
    return (new Date(startDate) > new Date(dateEnd)) ? true : false;
  }

  compareIntervalValues(): boolean {
    if(!this.discountTypeForm.get('intervalValueStart')?.value || !this.discountTypeForm.get('intervalValueEnd')?.value) {
      return true
    }
    const start = this.discountTypeForm.get('intervalValueStart')?.value;
    const end = this.discountTypeForm.get('intervalValueEnd')?.value;

    // Si alguno es null o undefined, tú decides qué devolver
    if (start == null || end == null) return false;

    return end > start;
  }
}    
